export const contentTypes = [
    {
        value: "text",
        label: "Text",
        imgSrc: "https://console.twilio.com/ContentTemplates/text-preview.png",
    },
    {
        value: "media",
        label: "Media",
        imgSrc: "https://console.twilio.com/ContentTemplates/media-preview.png",
    },
    {
        value: "quick_reply",
        label: "Quick reply",
        imgSrc: "https://console.twilio.com/ContentTemplates/quick-replies-preview.png",
    },
    {
        value: "call_to_action",
        label: "Call to action",
        imgSrc: "https://console.twilio.com/ContentTemplates/cta-preview.png",
    },
    {
        value: "list_picker",
        label: "List picker",
        imgSrc: "https://console.twilio.com/ContentTemplates/list-preview.jpg",
    },
    {
        value: "card",
        label: "Card",
        imgSrc: "https://console.twilio.com/ContentTemplates/card-preview.jpg",
    },
    {
        value: "whatsapp_card",
        label: "WhatsApp card",
        imgSrc: "https://console.twilio.com/ContentTemplates/card-preview.jpg",
    },
    {
        value: "whatsapp_authentication",
        label: "WhatsApp Authentication",
        imgSrc: "https://console.twilio.com/ContentTemplates/authentication-preview.jpg",
    },
    // {
    //     value: "catalog",
    //     label: "Catalog",
    //     imgSrc: "https://console.twilio.com/ContentTemplates/catalog-preview.svg",
    // },
];
